import Api from '@/api/rest/MaterialApi';

export default new Api();
